import Cookies from "universal-cookie";
import { cookie_slug } from "../config/cookie";

const cookies = new Cookies();

/**
 * Every cookie this portal writes is `SameSite=Lax` (sent on a top-level
 * navigation, so a link from an email still arrives signed in, but not on
 * cross-site sub-requests) and `Secure` whenever the page is served over
 * HTTPS. Plain-HTTP local dev keeps working without `Secure`
 * (sellsmart-api#4334 S6, ADR-11).
 *
 * The caller's options object is copied, not mutated: login passes one
 * shared object to a dozen calls.
 */
export const setCookie = (key: any, value: any, options: any = {}) => {
  const isHttps =
    typeof window !== "undefined" && window.location.protocol === "https:";
  cookies.set(cookie_slug + key, value, {
    ...options,
    path: "/",
    sameSite: "lax",
    ...(isHttps ? { secure: true } : {}),
  });
};

export const removeCookie = (key: any) => {
  cookies.remove(cookie_slug + key, { path: "/" });
};

export const getCookie = (key: any) => {
  return getCookieFromBrowser(key);
};

const getCookieFromBrowser = (key: any) => {
  return cookies.get(cookie_slug + key);
};

export const clearAllCookies = () => {
  const allCookies = cookies.getAll();

  Object.keys(allCookies).forEach((cookieName) => {
    cookies.remove(cookieName, { path: "/" });
  });
};
